import { PropsWithChildren, ReactNode } from 'react';

import { Button, ButtonProps, useDisclosure } from '@chakra-ui/react';

import { Modal, ModalProps } from './modal';

export type ModalButtonProps = PropsWithChildren<{
  buttonProps: ButtonProps;
  modalProps: Omit<ModalProps, 'isOpen' | 'onClose' | 'children'> & {
    renderModalContent: (res: { onClose: () => void }) => ReactNode;
  };
}>;

export function ModalButton({ buttonProps, modalProps, children }: ModalButtonProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Button
        {...buttonProps}
        onClick={(e) => {
          onOpen();
          buttonProps?.onClick?.(e);
        }}
      >
        {children}
      </Button>
      <Modal {...modalProps} isOpen={isOpen} onClose={onClose}>
        {modalProps?.renderModalContent({ onClose })}
      </Modal>
    </>
  );
}
